<div class="flex flex-col gap-4">
	<p>
		You’re about to remove access for the below contact. They will no longer be
		able to edit the intake form.
	</p>

	<div class="flex items-center gap-2 border rounded-xl p-4 bg-gray-50">
		<atomic-name-badge
			[firstName]="modalData.invitee?.name?.split(' ')[0] || ''"
			[lastName]="modalData.invitee?.name?.split(' ').slice(1).join(' ') || ''"
			size="small"
		></atomic-name-badge>

		<span>{{ modalData.invitee?.displayName || modalData.invitee?.name }}</span>
	</div>
</div>
